import { getCookie, setCookie, SR_LAST_SEEN_DATE_COOKIE_NAME } from 'util/cookie-utils'
import globalStore from 'init/global-store'

const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365

function setLastSeenSellerRatingDate(): void {
  if (globalStore.disableAllCookies) {
    return
  }
  // setting to now in milliseconds UTC, expiring in a year
  setCookie(SR_LAST_SEEN_DATE_COOKIE_NAME, Date.now(), ONE_YEAR_SECONDS)
}

function getLastSeenSellerRatingDate(): number {
  const value = getCookie(SR_LAST_SEEN_DATE_COOKIE_NAME)
  return value ? Number(value) : null
}

export default { getLastSeenSellerRatingDate, setLastSeenSellerRatingDate }
